import { render, staticRenderFns } from "./DeleteModel.vue?vue&type=template&id=38507679&scoped=true"
import script from "./DeleteModel.vue?vue&type=script&lang=js"
export * from "./DeleteModel.vue?vue&type=script&lang=js"
import style0 from "./DeleteModel.vue?vue&type=style&index=0&id=38507679&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38507679",
  null
  
)

export default component.exports